import React from "react";
import PropTypes from "prop-types";
import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../redux/reducer/auth/authReducer";

export default function PrivateRoute({ children }) {
  // Router State
  const navigate = useNavigate();
  // Redux State
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.isLogin);
  const token = useSelector((state) => state.auth.dataToken);
  const exp = token.exp;
  var milisNowDate = Date.now();

  const checkExpired = () => {
    if (token) {
      if (milisNowDate / 1000 < exp) {
        return false;
      } else {
        dispatch(authActions.logout());
        navigate("/dashboard");
        return true;
      }
    } else {
      return true;
    }
  };

  if (!user || checkExpired()) {
    return <Navigate to="/" replace />;
  }

  return children;
}

PrivateRoute.propTypes = {
  children: PropTypes.any,
  user: PropTypes.any,
  checkExpired: PropTypes.func,
};
